module.exports = __webpack_public_path__ + "files/8e1aeb707b3b74749f84bd82398234c0.png";